import React from "react";

import LoadingSvg from "../../spinners/LoadingSvg";

interface PurchaseOrderSavingOverlayProps {
  message?: string;
}

export default function PurchaseOrderSavingOverlay({
  message = "Saving purchase order…",
}: PurchaseOrderSavingOverlayProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#0F172A] bg-opacity-35 backdrop-blur-[1px]"
      role="status"
      aria-live="polite"
    >
      <div className="rounded-2xl border border-[#E2E8F0] bg-white px-8 py-6 shadow-xl">
        <div className="flex flex-col items-center gap-3">
          <LoadingSvg />
          <p className="text-sm font-semibold text-[#0F172A]">{message}</p>
        </div>
      </div>
    </div>
  );
}
